@if (typeReport()) {
  @if (exposures(); as exposures) {
    @if (exposures.length > 0) {
      <div class="flex justify-between items-center w-full py-1 mb-3">
        <span class="text-[10px] font-bold uppercase min-w-fit max-w-fit w-full mr-1">Source of funds Categories</span>
        <span class="h-[1px] w-full bg-[#022D35]"></span>
        <app-info class="w-[14px] h-[14px] ml-1" [currentColor]="'text-[#9AABAE]'"
                  [text]="'This list includes categories of fund sources for transactions (both incoming and outgoing).'"></app-info>
      </div>

      <div>
        @for (exposure of exposures; track $index) {
          @if (calcPercentForExposures(exposure.value) !== 0) {
            <div class="flex justify-between items-start mb-1 pb-1 border-b border-solid border-[#F2F2F2]">
              <div class="flex flex-col">
                <div class="leading-[1.3] text-[#234542] text-[14px]">
                  {{ exposure.category | titlecase }}
                </div>
                <div class="flex items-center">
                  <span class="leading-[1.2] text-[11px] text-[#567474] mr-1">{{ exposure.value | number:('1.2-2') }}
                    USDT</span>
                  <span
                    class="text-[11px] font-bold text-[#45525B] rounded-[60px] bg-[#23454233] px-1 py-[2px]">{{ calcPercentForExposures(exposure.value) }}
                    %</span>
                </div>
              </div>
              <div>
                <app-report-status [risk]="(exposure.category | amlCategoryTransformToRisk)"></app-report-status>
              </div>
            </div>
          }
        }
      </div>
    }
  }
}
